import Clickable from "@components/clickable"
import Modal from "@components/modal"
import Games from "@components/newGames"
import APP_2_3 from "@images/new_image/app/APP_2_3.png"
import PC_2_3 from "@images/new_image/pc/PC_2_3.png"
import classnames from "@src/utils/classnames"
import React, { useCallback, useState } from "react"
import { games as gamesData } from "./gamesData"
import styles from "./indie.module.scss"

const sliceGames = (i, shownLimit) => {
  const index = i % gamesData.length
  const end = index + shownLimit
  const remain = gamesData.length - end
  let sliced = gamesData.slice(index, end)
  return sliced
    .concat(remain < 0 ? gamesData.slice(0, Math.abs(remain)) : [])
    .concat([{ id: "more" }])
}

const Info = ({ isApp, renderItem }) => {
  const [index, setIndex] = useState(0)
  const [isOpen, setIsOpen] = useState(false)
  const shownLimit = isApp ? 5 : 7

  const handleRefresh = useCallback(() => {
    setIndex(index => {
      return index + shownLimit
    })
  }, [shownLimit])

  const shownGames = sliceGames(index, shownLimit)

  return (
    <>
      <div className={classnames("contentContainer", styles.container)}>
        <Games
          games={shownGames}
          onMoreClick={() => {
            setIsOpen(true)
          }}
        />
      </div>
      <Clickable onClick={handleRefresh}>
        {renderItem(PC_2_3, APP_2_3)}
      </Clickable>
      <Modal
        isOpen={isOpen}
        onRequestClose={() => {
          setIsOpen(false)
        }}
      >
        <Games games={gamesData} />
      </Modal>
    </>
  )
}

export default Info
